export function getIsReactNative() {
    return Boolean(window.ReactNativeWebView);
}
